import React from 'react';
import LegalPage from './Legalpage';

// Update this date every time you change the text below
const UPDATED = 'October 7, 2026';
const BRAND = 'RoboMind Academy'; // use your registered business name if different

const SECTIONS = [
  {
    id: 'collect',
    title: 'Information we collect',
    blocks: [
      'We only collect what we need to teach and run our classes:',
      [
        'Parent details: name, phone (WhatsApp) and email, when you book a trial or enroll',
        'Student details: first and last name, age, course, class attendance, progress, projects and certificates',
        'Account details: username and password for enrolled students and teachers',
        'Payment records: package, amount and date of payment',
        'Messages you send us by WhatsApp, email or phone',
        'Technical data: device and browser type, pages visited and cookies (see “Cookies and ads” below)',
      ],
    ],
  },
  {
    id: 'use',
    title: 'How we use it',
    blocks: [
      [
        'To book and run classes, and match the student with a teacher',
        'To send class codes, schedules, reminders and progress updates',
        'To manage enrollments, payments and student accounts',
        'To issue certificates and show achievements (see below)',
        'To improve our courses and website',
        'To measure our ads (for example, how many families booked a trial)',
        'To meet legal requirements',
      ],
    ],
  },
  {
    id: 'public',
    title: 'What we show publicly',
    blocks: [
      'To protect children’s privacy, on our website we only show a student’s first name and last initial, their course, number of completed classes and certificates. We never publish full names, ages, contact details or school names.',
      'We only publish photos or videos of a child with a parent’s permission. A parent can ask us to remove any of this at any time.',
    ],
  },
  // ---- Fill this if you record classes (empty = hidden on the page) ----
  {
    id: 'recordings',
    title: 'Class recordings',
    blocks: [
      // e.g. 'We do not record classes.'  OR
      // e.g. 'Classes may be recorded for quality and safety. Recordings are kept for ... days and are only seen by our team.'
    ],
  },
  // ---------------------------------------------------------------------
  {
    id: 'cookies',
    title: 'Cookies and ads',
    blocks: [
      'Our website uses the Meta Pixel (Facebook and Instagram) to measure our ads, for example when someone books a free trial. Meta may use cookies to do this.',
      'You can block or delete cookies in your browser settings, and manage how Meta uses your data for ads in your Facebook or Instagram settings.',
    ],
  },
  {
    id: 'services',
    title: 'Services we use',
    blocks: [
      'We use trusted third-party services to run our classes. They only receive what they need:',
      [
        'Zoom, for live online classes',
        'WhatsApp, for messages with families',
        'Meta (Facebook and Instagram), for ads and measurement',
        'Website hosting and email providers',
      ],
      'Each of these services has its own privacy policy.',
    ],
  },
  {
    id: 'sharing',
    title: 'Sharing',
    blocks: [
      'We do not sell personal data. We only share it:',
      [
        'With the services listed above, to run our classes',
        'When the law requires it',
        'To protect the safety of a student, our team or others',
        'With your permission',
      ],
    ],
  },
  {
    id: 'security',
    title: 'Keeping it safe',
    blocks: [
      'Our website uses secure (HTTPS) connections, accounts are protected by passwords, and only team members who need personal data can access it.',
      'No online system is 100% secure, but we take reasonable steps to protect your information and will tell affected families if a serious problem happens.',
    ],
  },
  {
    id: 'retention',
    title: 'How long we keep it',
    blocks: [
      'We keep personal data while the student is learning with us, and afterwards only as long as needed for records, certificates, legal reasons or disputes. Trial bookings that do not lead to enrollment can be deleted on request.',
    ],
  },
  {
    id: 'rights',
    title: 'Your rights',
    blocks: [
      'You can ask us to:',
      [
        'See the personal data we hold about you or your child',
        'Correct anything that is wrong',
        'Delete your or your child’s data, unless we must keep it by law',
        'Stop sending you marketing messages',
      ],
      'Contact us using the details below. We will reply as soon as we can.',
    ],
  },
  {
    id: 'children',
    title: 'Children’s privacy',
    blocks: [
      'Our students are children and teens, so bookings are made by a parent or guardian. We collect only what we need to teach, and parents can review, correct or delete their child’s information at any time.',
    ],
  },
  {
    id: 'changes',
    title: 'Changes to this policy',
    blocks: [
      'We may update this policy. The date at the top shows the latest version. If we make an important change, we will tell enrolled families.',
    ],
  },
];

const PrivacyPolicy = () => (
  <LegalPage
    eyebrow="Legal"
    title="Privacy Policy"
    updated={UPDATED}
    intro={`This policy explains what information ${BRAND} collects, why, and how we protect it, especially for children.`}
    summary={[
      'We collect only what we need to teach and run classes.',
      'We never sell your data.',
      'Publicly, we only show a student’s first name and last initial.',
      'You can ask us to see, correct or delete your data at any time.',
    ]}
    sections={SECTIONS}
    related={{ to: '/terms', label: 'Read our Terms of Service' }}
  />
);

export default PrivacyPolicy;